import React from 'react';
import { Link } from 'react-router-dom';
import { APPLE_THEME, TYPOGRAPHY } from '../theme';

const Footer = () => {
  const footerSections = [
    {
      title: 'Hizmetler',
      links: [
  { text: 'iPhone Ekran Değişimi', path: '/hizmetler/iphone-ekran' },
  { text: 'iPhone Batarya Değişimi', path: '/hizmetler/iphone-batarya' },
  { text: 'iPad Şarj Soketi', path: '/hizmetler/ipad-sarj-soketi' },
  { text: 'Mac Kurumsal Destek', path: '/hizmetler/mac-kurumsal-destek' }
      ]
    },
    {
      title: 'Alım Rehberleri',
      links: [
        { text: 'İkinci El Cihaz Alımı', path: '/rehber/secondhand' },
        { text: 'iPhone Rehberi', path: '/rehber/iphone' },
        { text: 'iPad Rehberi', path: '/rehber/ipad' },
        { text: 'Aksesuarlar', path: '/rehber/accessories' }
      ]
    },
    {
      title: 'Destek',
      links: [
        { text: 'Garanti Sorgula', path: '/destek#support-warranty' },
        { text: 'SSS', path: '/destek#support-faq' },
        { text: 'İletişim', path: '/iletisim' },
        { text: 'Randevu', path: '/iletisim' }
      ]
    },
    {
      title: 'C-Store',
      links: ['Hakkımızda', 'Kariyer', 'Basın', 'Gizlilik']
    }
  ];

  return (
    <footer 
      className="px-6"
      style={{ 
        backgroundColor: APPLE_THEME.lightMetalicGray
      }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="border-t" style={{ borderColor: '#e5e5ea' }} />

        <div className="grid md:grid-cols-4 gap-8 py-10">
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 
                className="mb-3"
                style={{ 
                  color: '#6e6e73',
                  fontFamily: TYPOGRAPHY.body,
                  fontSize: 12,
                  fontWeight: 600,
                  letterSpacing: '0.3px'
                }}
              >
                {section.title}
              </h3>
              <div className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <div key={linkIndex}>
                    {typeof link === 'string' ? (
                      <span
                        className="transition-colors duration-200"
                        style={{ 
                          color: '#424245',
                          fontFamily: TYPOGRAPHY.body,
                          fontSize: 13,
                          opacity: 0.7,
                          lineHeight: 1.8
                        }}
                        aria-disabled
                      >
                        {link}
                      </span>
                    ) : (
                      <Link 
                        to={link.path}
                        className="transition-colors duration-200 link-apple"
                        style={{ 
                          color: '#424245',
                          fontFamily: TYPOGRAPHY.body,
                          fontSize: 13,
                          lineHeight: 1.8
                        }}
                      >
                        {link.text}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="border-t" style={{ borderColor: '#e5e5ea' }} />

        <div 
          className="text-center py-6"
          style={{ 
            color: '#6e6e73',
            fontFamily: TYPOGRAPHY.body,
            fontSize: 12
          }}
        >
          © {new Date().getFullYear()} C-Store. Tüm hakları saklıdır.
        </div>
      </div>
    </footer>
  );
};

export default Footer;